import { useNavigate, useParams } from "react-router-dom";
import { BLOG_LIST_ROUTE, BLOG_ADD_ROUTE } from "constants/routeEnum";
import callApi from "Common/utils/apiCaller";
import * as Yup from "yup";
import { useFormik } from "formik";
import { showNotification } from "Common/utils/Notification";
import { useEffect, useState } from "react";
import { TailSpin } from "react-loader-spinner";
import { imageUploader } from "Common/utils/imageUploader";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import { getImageUrl } from "Common/utils/ImageDomain";
import PermissionSwitch from "../../Common/Components/PermissionLocks/PermissionSwitch";
import { ToastContainer } from "react-toastify";
import BreadCrumb from "Common/BreadCrumb";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import HtmlCode from "Common/Components/HtmlCode/HtmlCode";
import Drawer from "Common/Components/Drawer";
import ImageView from "Common/Components/ImageView/ImageView";
import { X } from "lucide-react";
import ImageData from "../../Common/Components/customImage/Image";

const AddBlog = () => {
  const navigate = useNavigate();

  const [CategoryId, setCategoryId] = useState<any>();
  const [imageLink, setImageLink] = useState<any>();
  const [blogType, setBlogType] = useState<any>("blog");
  const [content, setContent] = useState<string>("");
  const [author, setAuthor] = useState<any>();
  const [authorList, setAuthorList] = useState<any>();
  const [authorId, setAuthorId] = useState<any>("");
  const [category, setCategory] = useState([]);

  const [loader, setLoader] = useState<any>(false);
  const [imageData, setImageData] = useState<any>("");
  const [showImage, setShowImage] = useState<any>(false);
  const toggleImage = () => setShowImage(!showImage);
  useEffect(() => {
    if (imageData && imageData?.media_url) {
      if (imageData?.content_type?.split("/")[0] === "image") {
        setImageLink(imageData);
      } else {
        showNotification("Please select Image", "error");
      }
    }
  }, [imageData]);
  const selectProperties = createSelector(
    (state: any) => state.Login,
    (profile) => ({
      permission: profile.permission,
      user: profile.user,
    })
  );

  const { permission, user } = useSelector(selectProperties);

  const onAutherList = async () => {
    const localData = await callApi("v1/blog-author/list", "post", {
      pageNum: 1,
      pageSize: 100,
    });
    let arr = [];

    if (localData?.status === "Success") {
      for (let item of localData?.data.blog_authorList) {
        arr.push({ label: item.name, value: item.name });
      }
      // arr.push({ label: "Select author name", value: "Select..." });
      setAuthorList(arr);
      setAuthor(localData?.data?.blog_authorList);
    }
  };

  useEffect(() => {
    if (!authorList) {
      onAutherList();
    }
  }, [authorList]);
  useEffect(() => {
    fetchCategory();
  }, []);
  const fetchCategory = async () => {
    const localData = await callApi("v1/blog-category/list", "post", {
      filters: {
        // is_internal_user: true,
      },
    });

    if (localData?.status === "Success") {
      setCategory(
        localData.data.blog_categoryList.map((item) => {
          return {
            label: item.name,
            value: item.slug,
          };
        })
      );
    }
    // console.log(localData.data.blog_categoryList);
  };

  const handleAuthorList = (selectedOption: any) => {
    if (selectedOption.value === "Select...") {
      setAuthorId("");
    } else {
      for (let item of author) {
        if (item.name === selectedOption.value) {
          setAuthorId(item._id);
        }
      }
    }
  };
  //add serach for author
  interface autherOption {
    readonly value: string;
    readonly label: string;
  }
  const opAuther: readonly autherOption[] = authorList;
  const filterAuthor = (inputValue: string) => {
    return opAuther.filter((i: any) =>
      i.label.toLowerCase().includes(inputValue?.toLowerCase())
    );
  };

  const loadOptions = (
    inputValue: string,
    callback: (options: autherOption[]) => void
  ) => {
    setTimeout(() => {
      callback(filterAuthor(inputValue));
    }, 1000);
  };

  const options = [
    { value: "Select...", label: "Select Blog Type" },
    { value: "blog", label: "blog" },
  ];

  const handleChange = (selectedOption: any) => {
    if (selectedOption.value === "Select...") {
      setBlogType("");
    } else {
      setBlogType(selectedOption.value);
    }
  };
  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      // url: "",
      // page_title: "",
      // canonical_url: "",
      // meta_keyword: "",
      // meta_description: "",
      heading: "",
    },
    validationSchema: Yup.object({
      // page_title: Yup.string().required("Please enter page title"),
      // url: Yup.string().required("Please enter url"),
      // meta_description: Yup.string().required("Please enter meta description"),
      // meta_keyword: Yup.string().required("Please enter meta keyword"),
      // canonical_url: Yup.string().required("Please enter meta canonical url"),
      heading: Yup.string().required("Please enter heading"),
    }),

    onSubmit: async (values) => {
      const updateData = {
        ...values,
      };
      if (!!!authorId) {
        showNotification("Please select author", "error");

        return;
      }
      if (!!!blogType) {
        showNotification("Please select blog type", "error");

        return;
      }
      if (!content || content === undefined) {
        showNotification("Please add text", "error");

        return;
      }
      if (!!!imageLink?.media_url) {
        showNotification("Please add image", "error");
        return;
      }
      if (!!!CategoryId?.value) {
        showNotification("Please add category", "error");
        return;
      }
      try {
        setLoader(true);
        const res = await callApi(`v1/blog/new-blog`, "post", {
          blog: {
            blog_type: "blog",
            author_id: authorId,
            thumbnail_url: imageLink.media_url,
            text: content,
            ...values,

            canonical_url: " ",
            meta_description: " ",
            meta_keyword: " ",
            page_title: " ",
            blog_category: CategoryId?.value,
          },
          setBlogType: blogType,
        });
        setLoader(false);
        if (res && res?.status === "Success") {
          showNotification("Blog created successfully", "success");
          setImageLink("");
          setContent("");
          setBlogType("");
          setLoader(true);
          setTimeout(() => {
            navigate(BLOG_LIST_ROUTE);
            setLoader(false);
          }, 1000);
        }
      } catch (e) {
        showNotification("something went wrong", "error");
      }
    },
  });

  return (
    <>
      <BreadCrumb
        title={BLOG_ADD_ROUTE}
        pageTitle={BLOG_LIST_ROUTE}
        version="v1"
      />
      <ToastContainer />
      <div className="grid grid-cols-12 gap-x-5">
        <div className="col-span-12 card 2xl:col-span-12">
          <div className="p-6">
            <form
              className="create-form"
              id="create-form"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <input type="hidden" value="" name="id" id="id" />
              <input type="hidden" value="add" name="action" id="action" />
              <input type="hidden" id="id-field" />
              <div
                id="alert-error-msg"
                className="hidden px-4 py-3 text-sm text-red-500 border border-transparent rounded-md bg-red-50 dark:bg-red-500/20"
              ></div>
              <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                <div className="xl:col-span-12">
                  <div className="m-4 ml-0 xl:col-span-12">
                    {imageLink ? (
                      <div className="flex items-center">
                        <ImageData
                          imageLink={imageLink}
                          setImageLink={setImageLink}
                          setImageData={setImageData}
                        />
                        <div className="h-3 ml-3">
                          <div
                            onClick={() => {
                              setImageData(undefined);
                              toggleImage();
                            }}
                            className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                          >
                            Change
                          </div>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="mt-4 cursor-pointer">
                          <div
                            onClick={() => {
                              setImageData(undefined);
                              toggleImage();
                            }}
                            className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                          >
                            {"Add Image"}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  {/* <label
                    htmlFor="phoneNumberInput3"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Blog
                  </label> */}
                  {/* <Select
                    className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    options={options}
                    isSearchable={true}
                    defaultValue={options[0]}
                    onChange={(event: any) => handleChange(event)}
                    id="choices-single-default"
                  /> */}
                </div>
                <div className=" xl:col-span-12">
                  <label
                    htmlFor="phoneNumberInput42"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Heading
                  </label>
                  <input
                    type="text"
                    id="phoneNumberInput42"
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Enter heading"
                    name="heading"
                    onChange={validation.handleChange}
                    value={validation.values.heading || ""}
                  />
                  {validation.touched.heading && validation.errors.heading ? (
                    <p className="text-red-400">{validation.errors.heading}</p>
                  ) : null}
                </div>
                {/* <div className="mb-2 xl:col-span-12">
                  <label
                    htmlFor="phoneNumberInput32"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Url
                  </label>
                  <input
                    type="text"
                    id="phoneNumberInput32"
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Enter Url"
                    name="url"
                    onChange={validation.handleChange}
                    value={validation.values.url || ""}
                  />
                  {validation.touched.url && validation.errors.url ? (
                    <p className="text-red-400">{validation.errors.url}</p>
                  ) : null}
                </div> */}

                <div className="xl:col-span-12">
                  <label
                    htmlFor="phoneNumberInput1"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Author
                  </label>
                  <div className="xl:col-span-2">
                    {authorList ? (
                      // <Select
                      //   className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                      //   options={authorList}
                      //   isSearchable={false}
                      //   defaultValue={authorList[0]}
                      //   onChange={(event: any) => handleAuthorList(event)}
                      //   id="choices-single-default"
                      // />
                      <AsyncSelect
                        className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                        cacheOptions
                        loadOptions={loadOptions}
                        onChange={(event: any) => handleAuthorList(event)}
                        id="choices-single-default1"
                        defaultOptions
                      />
                    ) : null}
                  </div>
                </div>
                <div className="w-64 md:w-[700px] xl:col-span-2">
                  <label className="inline-block mb-2 text-base font-medium">
                    Category
                  </label>
                  <Select
                    className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    options={category}
                    isSearchable={false}
                    onChange={(event: any) => setCategoryId(event)}
                    id="choices-single-default"
                    value={CategoryId}
                  />
                </div>
                <div className="mb-6 xl:col-span-12">
                  <HtmlCode
                    content={content}
                    setContent={setContent}
                    label={"Text"}
                  />
                </div>
                {/* <div className="mt-4 cursor-pointer">
                  <div
                    onClick={() => {
                      setImageData(undefined);
                      toggleImage();
                    }}
                    className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    {"Add Image"}
                  </div>
                </div> */}
              </div>

              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="reset"
                  id="close-modal"
                  data-modal-close="addEmployeeModal"
                  className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                  onClick={() => navigate(BLOG_LIST_ROUTE)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  id="addNew"
                  disabled={loader}
                  style={{
                    minWidth: "130px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  {loader ? (
                    <span>
                      <TailSpin
                        visible={true}
                        height="20"
                        width="20"
                        color="#fff"
                      />
                    </span>
                  ) : (
                    "Add Blog"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Drawer
        show={showImage}
        onHide={toggleImage}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Image"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showImage}
            setEventData={setImageData}
            togleImage={toggleImage}
          />
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default AddBlog;
